module.exports = {"title":"Guardian erfassen","email":"Email","firstname":"Vorname","lastname":"Nachname","emailPlaceholder":"Email","firstnamePlaceholder":"Vorname","lastnamePlaceholder":"Nachname","cancelButton":"Abbrechen","inviteButton":"Einladen"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/add-guardian.json
// module id = JDKE
// module chunks = 1